
const physicalFrontends: string[] = ['https://pi-boxes.variocube.com'];

const physicalBackend = 'https://e3vnilbe60.execute-api.eu-west-1.amazonaws.com/dev';

interface ContainerSummary {
    uuid: string;
    currentConsignment?: string;
}

export enum ConsignmentCodeType {
    CarrierStorage = "CarrierStorage",
    CarrierRetrieval = "CarrierRetrieval",
    RecipientPickup = "RecipientPickup"

}

export interface ConsignmentCode {
    codeType: ConsignmentCodeType;
    code: string;
}

interface ConsignmentSummary {
    uuid: string;
    codes: ConsignmentCode[];
}

class PhysicalAdapter {

    readonly headers = {
        "Content-Type": "application/json",
        "Accept": "application/json"
    };

    isPhysicalContainerUrl(containerUrl: string): boolean {
        for(let frontend of physicalFrontends) {
            const completeUrl = `${frontend}/containers/`;
            if(containerUrl.startsWith(completeUrl)) {
                return true;
            }
        }
        return false;
    }

    async fetchContainer(containerUuid: string): Promise<ContainerSummary> {
        const response = await fetch(`${physicalBackend}/containers/${containerUuid}`);
        if(response.ok) {
            return await response.json();
        }
        throw new Error(`Failed to fetch container ${containerUuid}: ${response.statusText}`);
    }

    async fetchConsignment(consignmentUuid: string): Promise<ConsignmentSummary> {
        const response = await fetch(`${physicalBackend}/consignments/${consignmentUuid}`);
        if(response.ok) {
            return await response.json();
        }
        throw new Error(`Failed to fetch consignment ${consignmentUuid}: ${response.statusText}`);
    }

    async fetchStorageCode(containerUrl: string): Promise<string> {
        for(let frontend of physicalFrontends) {
            const completeUrl = `${frontend}/containers/`;
            if(containerUrl.startsWith(completeUrl)) {
                const containerUuid = containerUrl.substring(completeUrl.length);
                const container = await this.fetchContainer(containerUuid);
                if(container.currentConsignment) {
                    const consignment = await this.fetchConsignment(container.currentConsignment);
                    for(let code of consignment.codes) {
                        if(code.codeType == ConsignmentCodeType.CarrierStorage) {
                            return code.code;
                        }
                    }
                }
            }
        }
        throw new Error(`No storage code found for container ${containerUrl}`);
    }

}

export const physicalAdapter = new PhysicalAdapter();